import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateCompare',
})
export class DateComparePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value == 'compare') {
      return this.compare(args[0], args[1]);
    }
    return null;
  }

  private compare(data1: any, data2: any): boolean {
    // 如果其中任意一个是空 则直接返回false
    if (data1 == null || data2 == null) {
      return false;
    }
    const date1 = new Date(data1).getTime();
    const date2 = new Date(data2).getTime();
    return date1 > date2;

  }

}
